<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Loan Request List</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" aria-label="Close" aria-label="Close" (click)="closeModal()"></button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col d-flex justify-content-end align-items-end m-1">
        <button class="btn btn-info" (click)="isExpanded = !isExpanded" [attr.aria-expanded]="!isExpanded" aria-controls="collapseExample">Show Details</button>
      </div>
    </div>

    <ul class="nav nav-tabs">
      @if (containsPending() == true) {
        <li class="nav-item">
          <a class="nav-link" [ngClass]="checkActive('Pending')" role="tab" data-bs-toggle="tab" href="#tabPending" (click)="setSelectedMenu('Pending')">
            <p><i class="fab fa-readme"></i> Pending</p>
          </a>
        </li>
      }
      @if (containsApproved() == true) {
        <li class="nav-item">
          <a class="nav-link" [ngClass]="checkActive('Approved')" role="tab" data-bs-toggle="tab" href="#tabApproved" (click)="setSelectedMenu('Approved')">
            <p><i class="fas fa-thumbs-up"></i> Approved</p>
          </a>
        </li>
      }
    </ul>

    <div class="tab-content">
      <!--tabPending-->
      @if (checkMenuSelected("Pending")) {
        <div class="tab-pane" role="tabpanel" [ngClass]="checkActive('Pending')" id="tabPending">
          @for (request of loanRequestList; track request) {
            @if (request.Approved == undefined) {
              <!-- <ng-container *ngTemplateOutlet="requestView;context:{request:request}"></ng-container> -->
              <app-loan-request-details [request]="request" [isExpanded]="isExpanded"> </app-loan-request-details>
            }
          }
        </div>
      }

      <!--tabApproved-->
      @if (checkMenuSelected("Approved")) {
        <div class="tab-pane" role="tabpanel" [ngClass]="checkActive('Approved')" id="tabApproved">
          @for (request of loanRequestList; track request) {
            @if (request.Approved == true && request.LoanID == undefined) {
              <!-- <ng-container *ngTemplateOutlet="requestView;context:{request:request}"></ng-container> -->
              <app-loan-request-details [request]="request" [isExpanded]="isExpanded"> </app-loan-request-details>
            }
          }
        </div>
      }
    </div>

    <!--
    <ng-template #requestView let-request="request">

    </ng-template> -->
  </div>
</form>
